import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { addResizeCallback, removeResizeCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { getTransform, IndicatorPresentation } from './IndicatorPresentation.js';

var IndicatorWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(IndicatorWrapper, _React$Component);

  var _super = _createSuper(IndicatorWrapper);

  function IndicatorWrapper(props) {
    var _this;

    _classCallCheck(this, IndicatorWrapper);

    _this = _super.call(this, props);
    _this.checkIntervalTimespan = 500;

    _this.onResize = function () {
      return _this.setState({
        counter: _this.state.counter + 1,
        isResize: true
      });
    };

    _this.state = {
      counter: 1,
      isResize: false,
      fadeAnimation: false
    };
    return _this;
  }

  _createClass(IndicatorWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      addResizeCallback(this.onResize);
      this.checkInterval = setInterval(function () {
        return _this2.checkFullyRendered();
      }, this.checkIntervalTimespan);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeResizeCallback(this.onResize);
      clearInterval(this.checkInterval);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.isResize) {
        this.setState({
          isResize: false
        });
      }

      if (prevProps.activeElement === undefined && prevProps.activeElement !== this.props.activeElement) {
        this.setState({
          fadeAnimation: true
        });
      }
    }
  }, {
    key: "checkFullyRendered",
    value: function checkFullyRendered() {
      var _this3 = this;

      // it's possible for example in mobile view (e.g. SimpleHeader), that the active element
      // and it's parent (e.g. the Navigationblock) hasn't had valid dimensions at render time, e.g.:
      // DOMRect {x: 0, y: 0, width: 0, height: 0, top: 0, …}
      // instead of
      // DOMRect {x: 381.3333435058594, y: 112, width: 304, height: 120, top: 112, …}
      // in this case, check until a rerender is possible
      if (!this.props.activeElement) {
        return false;
      }

      var activeElementRect = this.props.activeElement.getBoundingClientRect();

      if (activeElementRect.width > 0 && activeElementRect.height > 0) {
        clearInterval(this.checkInterval); // now the navigation is rendered but let's not rerender too fast, maybe the element sizes are not correct yet.

        setTimeout(function () {
          return _this3.setState({
            counter: _this3.state.counter + 1
          });
        }, 300);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          activeElement = _this$props.activeElement,
          progress = _this$props.progress,
          isFullUnderline = _this$props.isFullUnderline,
          noAnimation = _this$props.noAnimation,
          direction = _this$props.direction;
      var _this$state = this.state,
          isResize = _this$state.isResize,
          fadeAnimation = _this$state.fadeAnimation;

      var _getTransform = getTransform(this.host, activeElement, progress, isFullUnderline, direction === "horizontal"),
          translate = _getTransform.translate,
          scale = _getTransform.scale;

      return /*#__PURE__*/React.createElement(IndicatorPresentation, Object.assign({}, this.props, {
        noAnimation: noAnimation || isResize,
        ref: function ref(r) {
          return _this4.host = r;
        },
        translate: translate,
        scale: scale,
        fadeAnimation: fadeAnimation
      }));
    }
  }]);

  return IndicatorWrapper;
}(React.Component);

IndicatorWrapper.defaultProps = {
  direction: "horizontal",
  translateOrthogonal: "0"
};

export { IndicatorWrapper };
